module.exports = __webpack_public_path__ + "media/images/flags/4x3/gnb-fe2fc61b32748be82f109a59bdaac3ce.svg";